import { Color, DataPointShape } from '@amzn/stencil-react-components/data-visualization';

/**
 * The list below species the configuration of each subsequent line that will be added
 * to a line chart. Each configuration should be unique and there should be enough configurations
 * to cover the maximum amount of lines that are expected to be added to a chart.
 */
export const LINE_CHART_LINE_CONFIGS = [
  {
    color: Color.Primary,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Green,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Neutral,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Pink,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Purple,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Red,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Yellow,
    shape: DataPointShape.Circle,
  },
  {
    color: Color.Primary,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Green,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Neutral,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Pink,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Purple,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Red,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Yellow,
    shape: DataPointShape.Square,
  },
  {
    color: Color.Primary,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Green,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Neutral,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Pink,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Purple,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Red,
    shape: DataPointShape.Diamond,
  },
  {
    color: Color.Yellow,
    shape: DataPointShape.Diamond,
  },
];